import { AdminPageHeader } from '@/components/patterns/admin-page'
import { DomainForm } from '@/components/forms/DomainForm'
import { InfoNotice } from '@/components/patterns/info-notice'
import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { domainQueries, useDomain } from '@/lib/services/domains/domains.query'
import { domainSchema } from '@/lib/services/domains/domains.schema'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { AlertTriangle, Globe } from 'lucide-react'
import { useState } from 'react'

export const Route = createFileRoute('/_authenticated/$orgId/website/domains/$domainId')({
  component: DomainPage,
  head: adminRouteTitleHead,
  params: {
    parse: (params) => domainSchema.pick({ domainId: true }).parse(params),
  },
  loader: async ({ context, params }) => {
    if (!context.ability.can('view', 'domains')) throw notFound()

    const domain = await context.queryClient.ensureQueryData(
      domainQueries.show({
        organizationId: params.orgId,
        domainId: params.domainId,
      })
    )
    return { domain, isReadOnly: !context.ability.can('edit', 'domains') }
  },
})

export function DomainPage() {
  const { domainId } = Route.useParams()
  const { data: domain } = useDomain(domainId)
  const [showSettingsWarning, setShowSettingsWarning] = useState(true)

  return (
    <div className="space-y-4 max-w-4xl">
      <AdminPageHeader icon={Globe} title={domain?.domain ?? 'Domain'} />
      {showSettingsWarning ? (
        <InfoNotice
          title="Changing domain settings can affect your website"
          tone="warning"
          icon={<AlertTriangle />}
          onDismiss={() => setShowSettingsWarning(false)}
          dismissLabel="Dismiss domain settings warning"
        >
          Changes to these settings can make your website unreachable. If you’re not comfortable
          making them yourself, please contact us and we’ll help.
        </InfoNotice>
      ) : null}
      <DomainForm domain={domain} />
    </div>
  )
}
